module.exports = __webpack_public_path__ + "static/media/velkoz.fa104ada.png";